import { useTranslation } from 'react-i18next';
import AttrLabel from '../Components/AttrLabel';
import PanelSection from '../Components/PanelSection';
import AttrField from '../Fields/AttrField';
import ColorField from '../Fields/ColorField';
import PaddingFields from '../Fields/PaddingFields';
import PixelField from '../Fields/PixelField';
import SelectField from '../Fields/SelectField';

function DividerPanel() {
    const { t } = useTranslation();

    return (
        <>
            <PanelSection label={t('Line')} defaultExpanded>
                <AttrLabel>{t('Height')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.borderTopWidth"
                    fallback="1px"
                />
                <AttrLabel>{t('Style')}</AttrLabel>
                <AttrField
                    Component={SelectField}
                    name="style.borderTopStyle"
                    options={[
                        { value: 'solid', label: t('Solid') },
                        // { value: 'dotted', label: t('Dotted') }, // a problem with duplicated dots
                        { value: 'dashed', label: t('Dashed') },
                    ]}
                />
                <AttrLabel>{t('Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="style.borderTopColor"
                    placeholder="#000000"
                />
                <AttrLabel>{t('Rounded Edges')}</AttrLabel>
                <AttrField
                    Component={PixelField}
                    name="style.borderRadius"
                    placeholder="0"
                />
            </PanelSection>
            <PanelSection label={t('Block Styles')}>
                <AttrLabel>{t('Background Color')}</AttrLabel>
                <AttrField
                    Component={ColorField}
                    name="style.backgroundColor"
                    placeholder={t('Transparent')}
                    property="containerAttributes"
                />
                <AttrLabel>{t('Padding')}</AttrLabel>
                <PaddingFields
                    name="style.padding"
                    property="containerAttributes"
                />
            </PanelSection>
        </>
    );
}

export default DividerPanel;
